import { APIProgramRewardsType } from '../programs-new/programs-new'
import { UtilityProgramDeviceType } from '../device'

export enum ProgramRewardPeriod {
  DAILY = 'daily',
  WEEKLY = 'weekly',
  MONTHLY = 'monthly',
  QUARTERLY = 'quarterly',
  YEARLY = 'yearly',
  ONE_TIME = 'one_time',
  UNSCHEDULED = 'unscheduled',
}
export type ChargeIncentiveProgram = {
  id: number
  reward_currency_per_kwh: number
  period_currency_cap: number
  plan: number
}
export type ProgramReward = {
  id: number
  created: string
  modified: string
  name: string
  description: string
  type: APIProgramRewardsType
  period: ProgramRewardPeriod
  start_date: string
  end_date: string
  last_payout_date: string | null
  next_payout_date: string | null
  amount: number
  earn_before_verification: boolean
  eligible_device_types: UtilityProgramDeviceType[]
  utility_program: number
  charge_incentive_program: ChargeIncentiveProgram | null
  external_payout: boolean | null
}
